import { Panel } from "@/components/KpiCard";
import { SmartTable } from "@/components/SmartTable";
import { money } from "@/lib/api";

const Th = ({ children, left }) => <th className={`whitespace-nowrap px-3 py-2 text-[11px] font-mono uppercase tracking-wider text-slate-500 ${left ? "text-left" : "text-right"}`}>{children}</th>;

export const DepensesPanel = ({ depenses, totaux }) => {
  if (!depenses?.lignes?.length) { return null; }
  const noms = depenses.logements;
  const totalLog = (n) => depenses.lignes.reduce((s, x) => s + (x.logements[n] || 0), 0);
  return (
    <Panel title={`Récapitulatif fiscal · Dépenses déductibles (${money(depenses.total)})`} testId="bilan-depenses-panel">
      <p className="mb-3 text-xs text-slate-500">
        Commissions des plateformes, frais de paiement Booking, abonnement Lodgify, intérêts hypothécaires (une ligne par immeuble, capital exclu) et charges affectées, répartis par logement. Inclus dans le rapport PDF (dernière page, « Récapitulatif fiscal ») et l'Excel (onglet « Dépenses déductibles »).
      </p>
      {totaux.interets_non_attribues > 0 && (
        <p className="mb-3 rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-800" data-testid="bilan-interets-non-attribues">
          {money(totaux.interets_non_attribues)} d'intérêts de prêt ne sont pas comptés : choisissez l'immeuble du prêt dans l'onglet « Intérêts hypothécaires ».
        </p>
      )}
      <div className="-mx-5 overflow-x-auto">
        <SmartTable id="depenses" data-export-titre="Dépenses déductibles" className="w-full min-w-[640px] text-sm" data-testid="bilan-depenses-table">
          <thead><tr><Th left>Catégorie</Th>{noms.map((n) => <Th key={n}>{n}</Th>)}<Th>Total</Th></tr></thead>
          <tbody>
            {depenses.lignes.map((x) => (
              <tr key={x.categorie} className="border-t border-slate-100 hover:bg-slate-50" data-testid={`bilan-depense-${x.categorie}`}>
                <td className="px-3 py-2.5 font-medium">{x.categorie}</td>
                {noms.map((n) => <td key={n} className="px-3 py-2.5 text-right tabular text-slate-600">{money(x.logements[n] || 0)}</td>)}
                <td className="px-3 py-2.5 text-right tabular font-medium">{money(x.montant)}</td>
              </tr>
            ))}
            <tr className="border-t border-slate-200 bg-slate-50 font-semibold" data-st-fixe="" data-testid="bilan-depenses-total">
              <td className="px-3 py-2.5">Total dépenses déductibles</td>
              {noms.map((n) => <td key={n} className="px-3 py-2.5 text-right tabular">{money(totalLog(n))}</td>)}
              <td className="px-3 py-2.5 text-right tabular">{money(depenses.total)}</td>
            </tr>
          </tbody>
        </SmartTable>
      </div>
      <p className="mt-3 text-sm text-slate-700" data-testid="bilan-depenses-resume">
        Revenus bruts {money(totaux.revenus_bruts)} − dépenses déductibles {money(depenses.total)} = <b className="tabular">bénéfice net {money(totaux.benefice_net)}</b>
      </p>
    </Panel>
  );
};
